
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"10.889","height":"14"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Icon material-delete","d":"M.778 12.445A1.56 1.56 0 002.333 14h6.222a1.56 1.56 0 001.556-1.556V3.111H.778zM10.889.778H8.167L7.389 0H3.5l-.778.778H0v1.555h10.889z","fill":"#3c3c3c"}})])
          )
        }
      }
    